export default "__VITE_ASSET__743cd06b__"